import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { GetNotification } from '../../../../graphql/queries';
import { UserManagementService } from '../../services/user-management.service';
import { NotificationExtended } from '../../models/notification';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  GetNotificationQuery,
  GetNotificationQueryVariables,
  QueryWithExecutionRecord,
  CreateNotificationMutationVariables,
  CreateNotificationMutation,
  CreateNotificationInput,
  DeleteNotificationMutation,
  DeleteNotificationMutationVariables,
  DeleteNotificationResponse,
  OnCreateNotificationSubscription,
  OnCreateNotificationSubscriptionVariables,
} from '../../../../API';
import { WorkbenchHistoryRecord } from '../../../market-fan-exploration/models/history-model';
import { Router } from '@angular/router';
import { CreateNotification, DeleteNotification } from '../../../../graphql/mutations';
import { Subscription } from 'rxjs';
import { onCreateNotification } from '../../../../graphql/subscriptions';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
})
export class NotificationComponent implements OnInit {
  private readonly pageSize = 30;

  isLoading = false;
  visibleCount = this.pageSize;

  isViewModalVisible = false;
  isViewModalLoading = false;
  selectedRow: WorkbenchHistoryRecord | null = null;
  selectedQueryRecord: QueryWithExecutionRecord | null = null;
  selectedQueryText = '';
  graphqlNotificationSubscription?: Subscription;
  userEmail?: string;

  constructor(
    private apiService: ApiService,
    private userManagementService: UserManagementService,
    private messageService: NzMessageService,
    private nzMessageService: NzMessageService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.userEmail = this.userManagementService.getEmail();
    this.getNotifications();
    this.listenRealTimeNotification(this.userEmail);
  }

  visibleNotifications: NotificationExtended[] = [];

  toggleNotification(notification: NotificationExtended, active: boolean): void {
    if (active) {
      this.visibleNotifications.forEach((item) => {
        if (item.notificationId !== notification.notificationId) {
          item.expanded = false;
        }
      });
    }

    notification.expanded = active;
  }

  async deleteNotification(event: MouseEvent, row: NotificationExtended): Promise<void> {
    event.stopPropagation();
    if (!row.notificationId) {
      return;
    }

    this.isLoading = true;
    const orgId = this.userManagementService.getOrgId();
    const username = this.userManagementService.getEmail();

    this.apiService
      .query<DeleteNotificationMutation, DeleteNotificationMutationVariables>(DeleteNotification, {
        input: {
          orgId,
          username,
          notificationId: row.notificationId,
        },
      })
      .then(async (response) => {
        const deleteResponse = response.data?.DeleteNotification as DeleteNotificationResponse;
        if (deleteResponse.statusCode !== 200) {
          this.nzMessageService.error(`Failed to delete notification: ${deleteResponse.message}`);
        } else {
          this.notifications = this.notifications.filter(
            (notification) => notification.notificationId !== row.notificationId,
          );
          this.updateVisibleNotifications();
          this.nzMessageService.success(`${row.name} is deleted successfully from notification.`);
        }
      })
      .catch((error) => {
        this.nzMessageService.error(`Failed to delete notification: ${error}`);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  isDropdownOpen = false;

  dropdownToggle(visible: boolean): void {
    this.isDropdownOpen = visible;
  }

  notifications: NotificationExtended[] = [];

  getNotifications(): void {
    this.isLoading = true;
    const orgId = this.userManagementService.getOrgId();
    const username = this.userManagementService.getEmail();
    this.apiService
      .query<GetNotificationQuery, GetNotificationQueryVariables>(GetNotification, {
        input: {
          orgId,
          username,
        },
      })
      .then((response) => {
        const result: NotificationExtended[] = (response?.data?.GetNotification || []).map((notification) => {
          const payload = JSON.parse(notification?.payload || '');
          const newItem = {
            ...notification,
            name: payload?.name,
            validationLogs: payload?.validationLogs,
            executedAt: payload?.executedAt,
            queryType: payload?.queryType,
            executionStatus: payload?.executionStatus,
            executionFailureReason: payload?.executionFailureReason,
            expanded: false,
          };
          return newItem;
        }) as NotificationExtended[];
        this.notifications = result.sort(
          (firstNotification, secondNotification) =>
            (Date.parse(secondNotification.createdAt ?? '') || 0) -
            (Date.parse(firstNotification.createdAt ?? '') || 0),
        );
        this.visibleCount = this.pageSize;
        this.updateVisibleNotifications();
      })
      .catch((error) => {
        console.error(error);
        this.notifications = [];
        this.visibleNotifications = [];
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  loadMore(): void {
    this.visibleCount = Math.min(this.visibleCount + this.pageSize, this.notifications.length);
    this.updateVisibleNotifications();
  }

  private updateVisibleNotifications(): void {
    this.visibleNotifications = this.notifications.slice(0, this.visibleCount);
  }

  trackNotification(index: number, notification: NotificationExtended): string {
    return notification.notificationId ?? `${notification.createdAt ?? 'notification'}-${index}`;
  }

  get hasMoreNotifications(): boolean {
    return this.visibleNotifications.length < this.notifications.length;
  }

  get remainingNotificationCount(): number {
    return this.notifications.length - this.visibleNotifications.length;
  }

  async updateNotification(row: NotificationExtended): Promise<void> {
    try {
      console.log('Row record :', row);
      const payload: CreateNotificationInput = {
        orgId: row.orgId,
        createdAt: row.createdAt,
        createdBy: row.createdBy,
        isRead: 'true',
        notificationId: row.notificationId,
        readAt: row.readAt,
        username: row.username,
        payload: row.payload,
      };
      const response = await this.apiService.query<CreateNotificationMutation, CreateNotificationMutationVariables>(
        CreateNotification,
        { input: payload },
      );
      const result = response?.data?.CreateNotification ?? null;
      console.log('Result ---:', result);
      if (result) {
        const payload = JSON.parse(row.payload || '{}');
        const queryType = payload.queryType;
        const executionId = payload.executionId;
        const queryId = payload.queryId;

        this.goToWorkbenchHistory(queryType, queryId, executionId);
      } else {
        this.messageService.success('Notification status updated failed.');
      }
    } catch (error) {
      console.error(error);
      this.messageService.error('Failed to update Notification.');
    } finally {
      this.isLoading = false;
    }
  }
  goToWorkbenchHistory(queryType: string, queryId: string, executionId: string) {
    const queryParams = { tab: 3, queryType: queryType.toLowerCase(), queryId: queryId, executionId: executionId };
    this.router.navigate([`/market-fan-exploration`], { queryParams });
  }

  listenRealTimeNotification(username: string): void {
    this.graphqlNotificationSubscription = this.apiService
      .subscription<OnCreateNotificationSubscription, OnCreateNotificationSubscriptionVariables>(onCreateNotification, {
        username,
      })
      .subscribe({
        next: (response) => {
          const notification = response?.data?.onCreateNotification;
          if (notification?.isRead === 'true') {
            return;
          }

          const payload = notification?.payload ? JSON.parse(notification.payload) : null;
          const queryName = payload?.name;
          const message = queryName
            ? `Query "${queryName}" execution notification is available in the Notifications section.`
            : 'A query execution notification is available in the Notifications section.';

          this.messageService.success(message, {
            nzDuration: 5000,
          });
        },
        error: (error: unknown) => {
          console.warn('Subscription error: ', error);
        },
      }) as Subscription;
  }

  printConsoleLog(): string {
    console.log('NotificationComponent: printConsoleLog() called');
    return '-';
  }
}
